import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFollowerGain = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "16px",
	height: "16px",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Group 4" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Design",
			stroke: "none",
			strokeWidth: 1,
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Overview",
				transform: "translate(-412.000000, -1630.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-Copy-5",
					transform: "translate(388.000000, 1614.000000)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group-4",
						transform: "translate(24.000000, 17.000000)",
						children: [/* @__PURE__ */ _jsx("path", {
							d: "M0.0273626774,14.9997656 C-0.0333419361,14.320095 0,13.6596426 0.198460623,13.0240333 C0.322213657,12.6274806 0.638158904,12.3708464 1.02512152,12.2492087 C1.57591627,12.0760099 2.14077387,11.9485131 2.69391244,11.7823453 C3.02204548,11.6834415 3.35486614,11.5761004 3.66143616,11.4232917 C4.35707822,11.0766597 4.47192478,10.5758127 4.14824497,9.86028352 C3.78940805,9.06717816 3.45846243,8.25626074 3.18728391,7.42917185 C2.9390747,6.67309682 2.92946509,5.88444448 3.13337634,5.10047951 C3.42752418,3.96660134 4.26566973,3.20466708 5.42421376,3.04529603 C6.26399998,2.92975202 7.06558213,3.01553114 7.77880275,3.53395581 C8.84195381,4.30737415 9.04094307,5.41922162 8.91719003,6.62294181 C8.80210909,7.74135162 8.3989742,8.77913842 7.87888332,9.7684108 C7.4335599,10.6151867 7.60114214,11.1532984 8.48569508,11.5027429 C9.0625061,11.730081 9.67470861,11.8648433 10.2707388,12.041792 C10.5154323,12.1146808 10.7692667,12.1683514 11.0013036,12.2710051 C11.4522522,12.4702189 11.7848385,12.7880235 11.8406211,13.3155886 C11.8989819,13.8682312 11.945858,14.4220456 12,15 L0.0273626774,15 L0.0273626774,14.9997656 Z",
							id: "Path",
							fillRule: "nonzero"
						}), /* @__PURE__ */ _jsx("path", {
							d: "M12.5,2.5 L14,2.5 C14.8284271,2.5 15.5,3.17157288 15.5,4 C15.5,4.82842712 14.8284271,5.5 14,5.5 L12.5,5.5 L12.5,7 C12.5,7.82842712 11.8284271,8.5 11,8.5 C10.1715729,8.5 9.5,7.82842712 9.5,7 L9.5,5.5 L8,5.5 C7.17157288,5.5 6.5,4.82842712 6.5,4 C6.5,3.17157288 7.17157288,2.5 8,2.5 L9.5,2.5 L9.5,1 C9.5,0.171572875 10.1715729,-0.5 11,-0.5 C11.8284271,-0.5 12.5,0.171572875 12.5,1 L12.5,2.5 Z",
							id: "Combined-Shape",
							stroke: "#FFFFFF"
						})]
					})
				})
			})
		})
	]
});
export default SvgFollowerGain;
